<app-header-simple></app-header-simple>
<!-- ======= Hero Section ======= -->
<section id="hero" class="d-flex flex-column justify-content-end align-items-center">
    <div id="heroCarousel" class="container carousel carousel-fade" data-ride="carousel">

        <!-- Titulo -->
        <div class="carousel-item active">
            <div class="carousel-container" style="height: 100%;">
                <h2 class="mt-4 animate__animated animate__faster animate__fadeInDown" style="margin-bottom: 0px;">
                    Tabla de Puntuaciones
                </h2>

                <marquee>
                    <p class="d-block d-sm-block d-md-none" style="font-size: 0.90rem;margin-bottom: 0px;">
                        <b>Recuerda que si pulsas sobre el nombre de algún participante puedes ver su quiniela</b>
                    </p>
                </marquee>
                <marquee>
                    <p class="d-none d-sm-none d-md-block" style="margin-bottom: 0px;">
                        <b>Recuerda que si pulsas sobre el nombre de algún participante puedes ver su quiniela</b>
                    </p>
                </marquee>

                <section id="services" class="services" style="padding: 1rem;width: 100%;">
                    <div class="container" style="max-width: 400px;" *ngIf="isIniciando == true">
                        <ng-lottie [options]="Futbolista" (animationCreated)="animationCreated($event)"></ng-lottie>
                        <p style='letter-spacing: 2px;text-transform: uppercase;font-family: "Poppins", sans-serif;font-weight: 700;'>
                            Cargando</p>
                    </div>
                    <app-loader *ngIf="isLoading == true && isIniciando == false"></app-loader>
                    <div *ngIf="isLoading == false && isIniciando == false">

                        <div class="input-group mb-2">
                            <div class="input-group-prepend">
                                <div class="input-group-text"><i class="icofont-search-2"></i></div>
                            </div>
                            <input type="text" id="buscarInput" (keyup)="buscar()" class="form-control" placeholder="Buscar por nombre...">
                        </div>

                        <div class="table-responsive mt-1">
                            <table class="table table-bordered table-sm animate__animated animate__faster animate__fadeInDown" id="tablePartidos">
                                <thead>
                                    <tr>
                                        <th class="text-white" scope="col">P</th>
                                        <th class="text-white" scope="col">NOMBRE</th>
                                        <th scope="col" class="text-center text-white">PUNTOS</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <ng-container *ngIf="this.jugadores.length > 0; else esperandoJugadores">
                                        <tr *ngFor="let jugador of this.jugadores; let i = index ">
                                            <td><a routerLink="/jugador/{{jugador.$key}}" style="text-decoration: none;color: white;">{{i+1}}</a></td>
                                            <td><a routerLink="/jugador/{{jugador.$key}}" style="text-decoration: none;color: white;">#{{jugador.numero}} - {{jugador.nombre}} {{jugador.apellido}}</a></td>
                                            <td><a routerLink="/jugador/{{jugador.$key}}" style="text-decoration: none;color: white;">{{jugador.puntaje}}</a></td>
                                        </tr>
                                    </ng-container>
                                    <ng-template #esperandoJugadores>
                                        <tr>
                                            <td colspan="3" class="text-center text-white">Actualmente no hay jugadores activos en la quiniela</td>
                                        </tr>
                                    </ng-template>
                                </tbody>
                            </table>
                        </div>
                        <div class="alert alert-dark animate__animated animate__faster animate__fadeInDown" role="alert">
                            Si presenta algún inconveniente puede comunicarse al email {{quiniela.email}} o al teléfono {{quiniela.telefono}}
                        </div>
                        <div class="text-white">
                            <i class="icofont-cloud-download icofont-3x" (click)="descargarCopiaSeguridad(idQuiniela)" style="margin-bottom: 5px;"></i>
                            <br>
                            <span style="font-size: 10px; margin-top: -10px;" (click)="descargarCopiaSeguridad(idQuiniela)">Descargar PDF copia de seguridad</span>
                        </div>
                    </div>
                </section>
                <!-- End Services Section -->
            </div>
        </div>
    </div>

    <svg class="hero-waves" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 24 150 28 " preserveAspectRatio="none">
        <defs>
            <path id="wave-path" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
        </defs>
        <g class="wave1">
            <use xlink:href="#wave-path" x="50" y="3" fill="rgba(255,255,255, .1)" />
        </g>
        <g class="wave2">
            <use xlink:href="#wave-path" x="50" y="0" fill="rgba(255,255,255, .2)" />
        </g>
        <g class="wave3">
            <use xlink:href="#wave-path" x="50" y="9" fill="#fff" />
        </g>
    </svg>


</section>
<!-- End Hero -->